import BrandStats from './BrandStats';

export default BrandStats;
